<template>
  <div class="page">
    <div class="notice-bagrd">
      <div class="notice-title">{{ msgData.title }}</div>
      <div class="notice-desc" :style="'color:' + `${msgData.descColor}`">
        {{ msgData.desc }}
      </div>
      <div
        class="notice-box"
        v-for="item in msgData.textList"
        :key="item.title"
      >
        <div class="notice">
          <div class="title">{{ item.title }}:</div>
          <span class="content" :style="'color:' + `${item.descColor}`">
            {{ item.desc }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMessageDetail } from "@/api/common";
import { STATUS_CODE_OK } from "@/config";
export default {
  name: "WxNotice",
  data() {
    return {
      msgData: {},
    };
  },
  created() {
    this.handleMessageDetail();
  },
  methods: {
    async handleMessageDetail() {
      let { data } = await getMessageDetail({
        messageId: this.$route.query.id,
      });
      if (data.code === STATUS_CODE_OK) {
        this.msgData = data.data;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background: rgb(237, 237, 237);
  .notice-bagrd {
    .notice-title {
      font-size: 18px;
    }
    .notice-desc {
      color: rgb(119, 119, 119);
      word-break: break-all;
      font-size: 16px;
    }
    background-color: #fff;
    padding: 20px;
    .notice-box {
      .notice {
        display: flex;
        margin: 15px 0px;
        font-size: 16px;
        .title {
          flex: 0 0 96px;
          color: rgb(137, 137, 137);
        }
        .content {
          flex: 1;
          word-break: break-all;
        }
      }
    }
  }
}
</style>
